import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReportIcon } from "src/components/ui-icons/card/ReportIcon";
import StarIcon from "src/components/ui-icons/reports/StarIcon";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { LayoutWithAsideAndContent } from "src/pages/LayoutWithAsideAndContent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { getItemsRequest } from "src/modules/spItems/api";
import {
  collectionsListName,
  departmentsListName,
  dependenciesListName,
  linesListName,
  MDWorkstationListName,
  myDocumentsListName,
  myDocumentsOWDCalendarWithRelationsListName,
  processesListName,
  sectorsListName,
  siteUrl,
  statusesListName,
  typesListName,
} from "src/api/config";
import LoadingOpBg from "src/components/LoadingOpBg";
import Form from "src/components/Form";
import _, { isObject } from "lodash";
import { selectItems } from "src/modules/spItems/selectors";
import moment from "moment";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser } from "src/modules/users/selector";
import Select from "src/components/ui/form/select";
import { NotificationSendOWDCalendarButton } from "src/pages/DashboardPage/acadia/notificationPage/calendar_owd_index";
import OWDCalendarTable from "src/components/tables/CalendarOWDTable";
import { setLocalItem } from "src/utils/localStorage";
import Loading from "src/components/Loading";
import { RootState } from "src/store/rootReducer";
import { docStatuses, notificationStatuses } from "src/api/config/systemSwitch";
import { SearchUI } from "src/components/ui/Search";
import { FavoriteButtonFilters } from "src/modules/favoriteFilters/md/FavoriteButtonFilters";
import { FavoriteFiltersList } from "src/modules/favoriteFilters/md/FavoriteFiltersList";
import { Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import { exportExcelFile } from "src/modules/exelExport/exelExport";
import { EmptyList } from "src/components/EmptyList";

const enumerateDaysBetweenDates = (startDate: Date, endDate: Date) => {
  let dates: any = [];

  const currDate = moment(startDate).startOf("day");
  const lastDate = moment(endDate).startOf("day");

  while (currDate.add(1, "days").diff(lastDate) < 0) {
    dates = [...dates, currDate.clone().toDate()];
  }
  return dates;
};

const enumerateMonthBetweenDates = (startDate: Date, endDate: Date) => {
  let dates: any = [];

  const currDate = moment(startDate).startOf("month");
  const lastDate = moment(endDate).startOf("month");

  while (currDate.add(1, "month").diff(lastDate) < 0) {
    dates = [...dates, currDate.clone().toDate()];
  }
  return dates;
};

function CalendarOWDFilters({ setFilters, setGetListDocuments, setLocalFilters, setFiltersParams, filtersParams, defaultUserFilter, userFilterCheck, reRenderUserFilter, setDisplayFilters }: any) {
  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const [defaultValues, setDefaultValues] = useState({});
  const [fields, setFields] = useState<any>([
    {
      type: "checkbox",
      require: false,
      key: "Notifications",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Статус выполнения графика OWD",
      placeholder: "Не выбрано",
      width: "w-full",
      optionsInputs: [
        {
          id: 1,
          name: "Запланировано",
          disabled: false,
        },
        {
          id: 2,
          name: "Не запланировано",
          disabled: false,
        },
        {
          id: 3,
          name: "Проведено",
          disabled: false,
        },
        {
          id: 4,
          name: "Просрочено",
          disabled: false,
        },
        {
          id: 5,
          name: "Неделя до срока",
          disabled: false,
        },
        {
          id: 6,
          name: "Отклонено",
          disabled: false,
        }
      ],
    },
    {
      type: "checkbox",
      require: false,
      key: "Status",
      isFilter: true,
      title: "Статус документа",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Collection",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Коллекция",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Department",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Подразделения/Функция",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Sector",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Колонна/Направление/Отдел",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Process",
      searchInFilterCheckbox: true,
      title: "Блок колонны/Участок",
      isFilter: true,
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "DocType",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Тип документа",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      isFilter: true,
      require: false,
      title: "Рабочее место",
      key: "WorkPlaces",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Lines",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Линия розлива",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "radio",
      require: false,
      key: "Critical",
      isFilter: true,
      title: "Критичность",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      isFilter: true,
      title: "Название оборудования",
      searchApiField: "Title",
      key: "Equipments_Title",
      placeholder: "Введите название",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Производитель оборудования",
      key: "Equipments_Manufacturer",
      searchApiField: "Manufacturer",
      isFilter: true,
      placeholder: "Введите производителя",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Модель оборудования",
      key: "Equipments_Model",
      searchApiField: "Model",
      isFilter: true,
      placeholder: "Введите модель",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Тип оборудования",
      key: "Equipments_TypeEquipment",
      searchApiField: "TypeEquipment",
      isFilter: true,
      placeholder: "Введите тип",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "SAP № технического места",
      key: "Equipments_SAP",
      searchApiField: "SAP",
      isFilter: true,
      placeholder: "Введите SAP",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "ResponsibleForRevisionEmail",
      title: "Ответственный за пересмотр",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "AuthorEmail",
      title: "Создатель",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "dateRange",
      require: false,
      key: "DateForRevision",
      title: "Пересмотр документа",
      isFilter: true,
      placeholder: "дд.мм.гггг",
      width: "w-full",
    },
  ]);
  const [reportDocumentsFilter, setReportDocumentsFilter] = useState<any>({});

  const [dependenceFields, setDependenceFields] = useState<any>({
    Collection: null,
    Department: null,
    Sector: null,
    Process: null,
  });

  const collections: any = useAppSelector((state) => selectItems(state, collectionsListName));
  const departments: any = useAppSelector((state) => selectItems(state, departmentsListName));
  const sectors: any = useAppSelector((state) => selectItems(state, sectorsListName));
  const processes: any = useAppSelector((state) => selectItems(state, processesListName));
  const types: any = useAppSelector((state) => selectItems(state, typesListName));
  const lines: any = useAppSelector((state) => selectItems(state, linesListName));
  const statuses: any = useAppSelector((state) =>
    selectItems(state, statusesListName)
  );
  const [customLoading, setCustomLoading] = useState(true);
  const [resetFilters, setResetFiters] = useState(false);
  const [workplaces, setWorkplaces] = useState<any>([]);
  const [isDefaultDepartment, setDefaultDepartment] = useState(0);

  //Формируем данные фильтры по умолчанию
  useEffect(() => {
    setCustomLoading(true)
    const tempFieldsForm = [...fields];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (tempFieldsForm[i]["key"] === "Collection") {
        tempFieldsForm[i]["optionsInputs"] = collections.map((collection: any) => {
          return {
            id: collection.ID,
            name: collection.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Status") {
        tempFieldsForm[i]["optionsInputs"] = statuses.filter(status => status.ID === docStatuses.revision || status.ID === docStatuses.review || status.ID === docStatuses.cancel || status.ID === docStatuses.approval || status.ID === docStatuses.archive || status.ID === docStatuses.public).map(
          (status: any) => {
            return {
              id: status.ID,
              name: status.Title,
              disabled: false,
            };
          }
        );
      }
      if (tempFieldsForm[i]["key"] === "Department") {
        tempFieldsForm[i]["optionsInputs"] = departments.map((department: any) => {
          return {
            id: department.ID,
            name: department.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Sector") {
        tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
          return {
            id: sector.ID,
            name: sector.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Process") {
        tempFieldsForm[i]["optionsInputs"] = processes.map((process: any) => {
          return {
            id: process.ID,
            name: process.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "DocType") {
        tempFieldsForm[i]["optionsInputs"] = types.map((type: any) => {
          return {
            id: type.ID,
            name: type.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Lines") {
        tempFieldsForm[i]["optionsInputs"] = lines.map((line: any) => {
          return {
            id: line.ID,
            name: line.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "WorkPlaces") {
        tempFieldsForm[i]["optionsInputs"] = workplaces.map((place: any) => {
          return {
            id: place.ID,
            name: `${place.Location.get_lookupValue()}_${place.Workstation}`,
            disabled: false,
          };
        }).sort((a, b) => a.name.localeCompare(b.name, 'ru', { sensitivity: 'base' }));
      }
      if (tempFieldsForm[i]["key"] === "Critical") {
        tempFieldsForm[i]["optionsInputs"] = ["Критичный", "Не критичный"];
      }
    }
    setFields([...tempFieldsForm]);
    setCustomLoading(false);
  }, [collections, departments, sectors, processes, types, lines, workplaces, statuses]);

  useEffect(() => {
    if (Object.keys(currentUser).length > 0 && currentUser.id > 0) {
      setCustomLoading(true);
      let filtersDependDocuments: any = {};
      const tempFieldsForm = [...fields];
      Object.keys(dependenceFields).map((key) => {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === key) {
            tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i]["optionsInputs"].map((option: any) => {
              return {
                id: option.id,
                name: option.name,
                disabled: false,
              };
            });
          }
        }
      });
      if (dependenceFields["Collection"]) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Lines") {
            tempFieldsForm[i]["optionsInputs"] = lines
              .filter((line: any) =>
                dependenceFields["Collection"].some((depend: any) => depend.id === line.Collection.ID)
              )
              .map((line: any) => {
                return {
                  id: line.ID,
                  name: line.Title,
                  disabled: false,
                };
              });
          }
        }
      }
      Object.keys(dependenceFields).map((key) => {
        if (dependenceFields[key] && dependenceFields[key].length > 0) {
          filtersDependDocuments[key] = dependenceFields[key].map((item: any) => item.id);
        }
      });
      if (Object.keys(filtersDependDocuments).length === 0) {
        setFields([...tempFieldsForm]);
        setCustomLoading(false);
      } else {
        if (Object.keys(filtersDependDocuments).length > 0) {
          setCustomLoading(true);
          //Устанавливаем зависимости в фильтрах
          getItemsRequest({
            listName: dependenciesListName,
            filters: filtersDependDocuments,
            filtersType: "or",
            sortOrder: { name: "SortDepend", asc: true },
          }).then((results) => {
            const dependDocuments = [...results.items];
            const collectionIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Collection.get_lookupId()),
              _.isEqual
            );
            const departmentIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Department.get_lookupId()),
              _.isEqual
            );
            const sectorIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Sector.get_lookupId()),
              _.isEqual
            );
            const processIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Process.get_lookupId()),
              _.isEqual
            );
            for (let i = 0; i < tempFieldsForm.length; i++) {
              if (tempFieldsForm[i]["key"] === "Collection") {
                if (!filtersDependDocuments["Collection"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = collections.map((collection: any) => {
                    return {
                      id: collection.ID,
                      name: collection.Title,
                      disabled: false, //collectionIds.indexOf(collection.ID) === -1,
                      hide: collectionIds.indexOf(collection.ID) === -1
                    };
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Department") {
                if (!filtersDependDocuments["Department"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = departments.map((department: any) => {
                    return {
                      id: department.ID,
                      name: department.Title,
                      disabled: false, //departmentIds.indexOf(department.ID) === -1,
                      hide: departmentIds.indexOf(department.ID) === -1,
                      user_Department: department.User_Department
                    };
                  });
                  tempFieldsForm[i]["optionsInputs"].forEach((department: any) => {
                    if (department.user_Department.indexOf(currentUser.department) !== -1 && department.disabled) {
                      setDefaultDepartment(department.id);
                    }
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Sector") {
                if (!filtersDependDocuments["Sector"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
                    return {
                      id: sector.ID,
                      name: sector.Title,
                      disabled: false, //sectorIds.indexOf(sector.ID) === -1,
                      hide: sectorIds.indexOf(sector.ID) === -1,
                    };
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Process") {
                if (!filtersDependDocuments["Process"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = processes.map((process: any) => {
                    return {
                      id: process.ID,
                      name: process.Title,
                      disabled: false, //processIds.indexOf(process.ID) === -1,
                      hide: processIds.indexOf(process.ID) === -1
                    };
                  });
                }
              }
            }
            setFields([...tempFieldsForm]);
            setCustomLoading(false);
          });
        }
      }
    }
  }, [dependenceFields, currentUser]);

  useEffect(() => {
    setDependenceFields({
      Collection: null,
      Department: null,
      Sector: null,
      Process: null,
    });
  }, [resetFilters]);

  useEffect(() => {
    if (Object.keys(reportDocumentsFilter).length > 0) {
      const existsFiltersDocuments: any = {};
      Object.keys(reportDocumentsFilter).map((key) => {
        if (reportDocumentsFilter[key]) {
          if (Array.isArray(reportDocumentsFilter[key])) {
            if (reportDocumentsFilter[key].length > 0) {
              existsFiltersDocuments[key] = reportDocumentsFilter[key];
            }
          } else if (isObject(reportDocumentsFilter[key])) {
            if (Object.keys(reportDocumentsFilter[key]).length > 0) {
              existsFiltersDocuments[key] = reportDocumentsFilter[key];
            }
          } else {
            existsFiltersDocuments[key] = reportDocumentsFilter[key];
          }
        }
      });
      const tempFilters: any = {};
      const tempDisplayFilters: any = {};
      console.log("existsFiltersDocuments: ", existsFiltersDocuments);
      Object.keys(existsFiltersDocuments).map((key) => {
        if (key === "DateForRevision") {
          tempFilters[key] = {
            start:
              (existsFiltersDocuments[key] &&
                moment(existsFiltersDocuments[key].startDate).isValid() &&
                moment(existsFiltersDocuments[key].startDate).format("YYYY-MM-DD")) ||
              null,
            end:
              (existsFiltersDocuments[key] &&
                moment(existsFiltersDocuments[key].endDate).isValid() &&
                moment(existsFiltersDocuments[key].endDate).format("YYYY-MM-DD")) ||
              null,
          };
          tempDisplayFilters[key] = `Дата пересмотра от ${moment(
            existsFiltersDocuments[key].startDate
          ).format("DD.MM.YYYY")} до ${moment(
            existsFiltersDocuments[key].endDate
          ).format("DD.MM.YYYY")}`;
        } else if (
          key === "Collection" ||
          key === "Department" ||
          key === "Sector" ||
          key === "Process" ||
          key === "Lines" ||
          key === "DocType" ||
          key === "WorkPlaces" ||
          key === "Status"
        ) {
          tempFilters[key] = existsFiltersDocuments[key].map((item: any) => item.id);
          tempDisplayFilters[key] = existsFiltersDocuments[key].map(
            (item: any) => item.name
          );
        } else if (key === "AuthorEmail" || key === "ResponsibleForRevisionEmail") {
          tempFilters[key] = `${existsFiltersDocuments[key][0]["value"]}*`;
          tempDisplayFilters[key] = existsFiltersDocuments[key][0]["label"];
        } else if (key === "Critical") {
          tempFilters[key] = (existsFiltersDocuments[key] === "Критичный" && true) || false;
          tempDisplayFilters[key] = existsFiltersDocuments[key];
        } else if (
          key === "Equipments_Title" ||
          key === "Equipments_Manufacturer" ||
          key === "Equipments_Model" ||
          key === "Equipments_TypeEquipment" ||
          key === "Equipments_SAP"
        ) {
          if (!Array.isArray(tempFilters["Equipments"])) {
            tempFilters["Equipments"] = [];
          }
          tempFilters["Equipments"] = [
            ...tempFilters["Equipments"],
            ...existsFiltersDocuments[key].map((equipment: any) => `${equipment.id}*`),
          ];
          tempDisplayFilters[key] = existsFiltersDocuments[key].map(
            (equipment: any) => `${equipment.name}`
          );
        } else if (key === "Notifications") {
          setLocalFilters([...existsFiltersDocuments[key]]);
          tempDisplayFilters[key] = existsFiltersDocuments[key].map(
            (item: any) => item.name
          );
        }
      });
      if (
        JSON.stringify(filtersParams) !== JSON.stringify(existsFiltersDocuments)
      ) {
        setFiltersParams(existsFiltersDocuments);
      }
      setDisplayFilters({ ...tempDisplayFilters });
      setFilters({ ...tempFilters });
    }
  }, [reportDocumentsFilter]);

  useEffect(() => {
    getItemsRequest({
      listName: MDWorkstationListName
    }).then((result) => {
      setWorkplaces([...result.items]);
    })
  }, []);

  useEffect(() => {
    if (collections.length > 0 && Object.keys(currentUser).length > 0 && currentUser.id > 0 && userFilterCheck && statuses.length > 0 && departments.length > 0) {
      let defaultObj: any = {};
      console.log('defaultUserFilter: ', defaultUserFilter);
      if (Object.keys(filtersParams).length > 0) {
        Object.keys(filtersParams).forEach(key => {
          if (filtersParams[key]) {
            defaultObj[key] = filtersParams[key];
          } else {
            defaultObj[key] = null;
          }
        });
        setDefaultValues(defaultObj);
      } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MDFullFilters)).length > 0) {
        Object.keys(JSON.parse(defaultUserFilter.MDFullFilters)).forEach(key => {
          if (JSON.parse(defaultUserFilter.MDFullFilters)[key]) {
            defaultObj[key] = JSON.parse(defaultUserFilter.MDFullFilters)[key];
          } else {
            defaultObj[key] = null;
          }
        });
        setDefaultValues(defaultObj);
      } else {
        let defaultLocationsIds: number[] = [];
        if (currentUser.isCollectionAdmin || currentUser.isCollectionEditor) {
          if (Array.isArray(currentUser.isCollectionAdmin) && currentUser.isCollectionAdmin.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isCollectionAdmin];
          }
          if (Array.isArray(currentUser.isCollectionEditor) && currentUser.isCollectionEditor.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isCollectionEditor];
          }
        }
        let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
        setDependenceFields({
          Collection: unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
            return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
          }) || null,
          Department: null,
          Sector: null,
          Process: null
        });
        fields.map((field: any) => {
          if (field.key === "Collection") {
            defaultObj[field.key] = unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
              return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
            }) || null;
          } else if (field.key === "Department") {
            defaultObj[field.key] = departments.filter(department => currentUser.department && department.User_Department && department.User_Department.indexOf(currentUser.department) !== -1).map(department => {
              return { id: department.ID, name: department.Title, disabled: false }
            }) || null;
          } else if (field.key === "Status") {
            defaultObj[field.key] = [
              {
                id: docStatuses.public,
                name: 'Опубликован',
                disabled: false
              },
              {
                id: docStatuses.review,
                name: 'На пересмотр',
                disabled: false
              }
            ]
          } else if (field.key === 'Notifications') {
            defaultObj[field.key] = [
              {
                id: 1,
                name: 'Запланировано',
                disabled: false
              },
            ]
          } else {
            defaultObj[field.key] = null;
          }
        });
        setDefaultValues(defaultObj);
      }
    }
  }, [resetFilters, collections, JSON.stringify(currentUser), userFilterCheck, reRenderUserFilter, statuses, departments]);

  useEffect(() => {
    if (isDefaultDepartment) {
      setDefaultValues((prevState) => {
        return { ...prevState, Department: null }
      });
    }
  }, [isDefaultDepartment]);

  return (
    <FlexCol className="relative">
      {customLoading && <LoadingOpBg />}
      {Object.keys(reportDocumentsFilter).length > 0 &&
        Object.keys(reportDocumentsFilter).some((key) => reportDocumentsFilter[key]) && (
          <div
            onClick={() => {
              setFiltersParams({});
              setReportDocumentsFilter({});
              setFilters({});
              setLocalFilters({});
              setResetFiters(!resetFilters);
              setGetListDocuments(false);
            }}
            className="p-5 flex flex-row group items-center text-[14px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap border-b"
          >
            <div className="flex flex-col">Сбросить фильтры</div>
            <div className="flex flex-col pt-1">
              <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_33_4954)">
                  <path
                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                    fill="#637381"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_33_4954">
                    <rect width="16" height="16" fill="white" transform="translate(0 12) rotate(-90)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        )}
      <Form
        type="report_documents_filters"
        setFormData={setReportDocumentsFilter}
        fieldsForm={fields}
        defaultValues={defaultValues}
        setDependenceFields={setDependenceFields}
      />
      {Object.keys(reportDocumentsFilter).length > 0 &&
        Object.keys(reportDocumentsFilter).some((key) => reportDocumentsFilter[key]) && (
          <div
            onClick={() => {
              setFiltersParams({});
              setReportDocumentsFilter({});
              setFilters({});
              setLocalFilters({});
              setResetFiters(!resetFilters);
              setGetListDocuments(false);
            }}
            className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
          >
            <div className="flex flex-col group-hover:underline">Сбросить фильтры</div>
            <div className="flex flex-col pt-1">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_33_4954)">
                  <path
                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                    fill="#637381"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_33_4954">
                    <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        )}
    </FlexCol>
  );
}

export function CalendarOwdReport() {
  const [localFilters, setLocalFilters] = useState([]);
  const [filters, setFilters] = useState<any>({});
  const [getListDocuments, setGetListDocuments] = useState(false);
  const [typePeriod, setTypePeriod] = useState({ id: "week", name: "Неделя" });
  const [valuePeriod, setValuePeriod] = useState({
    start: { value: moment().startOf("week"), label: moment().startOf("week").format("DD.MM.YY") },
    end: { value: moment().endOf("week"), label: moment().endOf("week").format("DD.MM.YY") },
  });
  const [renderPeriodDate, setRenderPeriodDate] = useState<any>([]);
  const [renderTableData, setRenderTableData] = useState<any>([]);
  const [filterRenderTableData, setFilterRenderTableData] = useState<any>([]);
  const [customLoading, setCustomLoading] = useState(true);
  const [listDocuments, setListDocuments] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useAppDispatch();
  const [nextPage, setNextPage] = useState<any>(null);
  const [columns, setColumns] = useState<any>([]);
  const [scrollDown, setScrollDown] = useState(false);
  const [allLoading, setAllLoading] = useState(false);
  const [openImportExel, setOpenImportExel] = useState(false);
  const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
  const [filtersParams, setFiltersParams] = useState({});
  const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
  const [userFilterCheck, setUserFilterCheck] = useState(false);
  const [reRenderUserFilter, setReRenderUserFilter] = useState(null);
  const [displayFilters, setDisplayFilters] = useState<any>({});
  const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");

  const [selectPeriodField, setSelectPeriodField] = useState({
    dataField: {
      require: false,
      type: "select",
      key: "periodOWD",
      title: "Выберите период",
      placeholder: "Выберите период",
      width: "w-full",
      options: [
        { id: "week", name: "Неделя" },
        { id: "month", name: "Месяц" },
        // { id: "year", name: "Год" },
      ],
    },
    onChange: setTypePeriod,
    value: typePeriod,
  });

  function handleSearch(value: string) {
    setSearchQuery(value);
  }

  // Оределение текущего периода в календаре
  useEffect(() => {
    setSelectPeriodField({ ...selectPeriodField, value: typePeriod });
    if (typePeriod.id === "week") {
      const start = moment().clone().startOf("week");
      const end = moment().clone().endOf("week");
      setValuePeriod({
        start: { value: start, label: start.format("DD.MM.YY") },
        end: { value: end, label: end.format("DD.MM.YY") },
      });
      setRenderPeriodDate([
        ...[start.toDate()],
        ...enumerateDaysBetweenDates(start.toDate(), end.toDate()),
        ...[end.toDate()],
      ]);
    }
    if (typePeriod.id === "month") {
      const start = moment().clone().startOf("month");
      const end = moment().clone().endOf("month");
      setValuePeriod({
        start: { value: start, label: start.format("MMMM YYYY") },
        end: { value: end, label: end.format("MMMM YYYY") },
      });
      setRenderPeriodDate([
        ...[start.toDate()],
        ...enumerateDaysBetweenDates(start.toDate(), end.toDate()),
        ...[end.toDate()],
      ]);
    }
    // if (typePeriod.id === "year") {
    //   const start = moment().clone().startOf("year");
    //   const end = moment().clone().endOf("year");
    //   setValuePeriod({
    //     start: { value: start, label: start.format("YYYY") },
    //     end: { value: end, label: end.format("MMMM YYYY") },
    //   });
    //   setRenderPeriodDate([
    //     ...[start.toDate()],
    //     ...enumerateMonthBetweenDates(start.toDate(), end.toDate()),
    //     ...[end.toDate()],
    //   ]);
    // }
  }, [typePeriod]);

  //Определение предыдущего периода в календаре
  const prevDateHandle = () => {
    setCustomLoading(true);
    if (typePeriod.id === "week") {
      const start = valuePeriod.start.value.clone().subtract(7, "days");
      const end = valuePeriod.end.value.clone().subtract(7, "days");
      setValuePeriod({
        start: { value: start, label: start.format("DD.MM.YY") },
        end: { value: end, label: end.format("DD.MM.YY") },
      });
      setRenderPeriodDate([
        ...[start.toDate()],
        ...enumerateDaysBetweenDates(start.toDate(), end.toDate()),
        ...[end.toDate()],
      ]);
    }
    if (typePeriod.id === "month") {
      const start = valuePeriod.start.value.clone().subtract(1, "months");
      const end = valuePeriod.end.value.clone().subtract(1, "months");
      setValuePeriod({
        start: { value: start, label: start.format("MMMM YYYY") },
        end: { value: end, label: end.format("MMMM YYYY") },
      });
      setRenderPeriodDate([
        ...[start.toDate()],
        ...enumerateDaysBetweenDates(start.toDate(), end.toDate()),
        ...[end.toDate()],
      ]);
    }
    // if (typePeriod.id === "year") {
    //   const start = valuePeriod.start.value.clone().subtract(1, "years");
    //   const end = valuePeriod.end.value.clone().subtract(1, "years");
    //   setValuePeriod({
    //     start: { value: start, label: start.format("YYYY") },
    //     end: { value: end, label: end.format("YYYY") },
    //   });
    //   setRenderPeriodDate([
    //     ...[start.toDate()],
    //     ...enumerateMonthBetweenDates(start.toDate(), end.toDate()),
    //     ...[end.toDate()],
    //   ]);
    // }
  };

  //Определение следующего периода в календаре
  const nextDateHandle = () => {
    setCustomLoading(true);
    if (typePeriod.id === "week") {
      const start = valuePeriod.start.value.clone().add(7, "days");
      const end = valuePeriod.end.value.clone().add(7, "days");
      setValuePeriod({
        start: { value: start, label: start.format("DD.MM.YY") },
        end: { value: end, label: end.format("DD.MM.YY") },
      });
      setRenderPeriodDate([
        ...[start.toDate()],
        ...enumerateDaysBetweenDates(start.toDate(), end.toDate()),
        ...[end.toDate()],
      ]);
    }
    if (typePeriod.id === "month") {
      const start = valuePeriod.start.value.clone().add(1, "months");
      const end = valuePeriod.end.value.clone().add(1, "months");
      setValuePeriod({
        start: { value: start, label: start.format("MMMM YYYY") },
        end: { value: end, label: end.format("MMMM YYYY") },
      });
      setRenderPeriodDate([
        ...[start.toDate()],
        ...enumerateDaysBetweenDates(start.toDate(), end.toDate()),
        ...[end.toDate()],
      ]);
    }
    // if (typePeriod.id === "year") {
    //   const start = valuePeriod.start.value.clone().add(1, "years");
    //   const end = valuePeriod.end.value.clone().add(1, "years");
    //   setValuePeriod({
    //     start: { value: start, label: start.format("YYYY") },
    //     end: { value: end, label: end.format("YYYY") },
    //   });
    //   setRenderPeriodDate([
    //     ...[start.toDate()],
    //     ...enumerateMonthBetweenDates(start.toDate(), end.toDate()),
    //     ...[end.toDate()],
    //   ]);
    // }
  };

  useEffect(() => {
    let tempColumns: any = [
      {
        title: "Документ",
        style: { width: "267px" },
        defaultDate: null,
        data: [],
      },
    ];
    renderPeriodDate.forEach((date: Date) => {
      if (typePeriod.id === "week" || typePeriod.id === "month") {
        tempColumns = [
          ...tempColumns,
          {
            title: moment(date).format("DD.MM.YYYY"),
            style: { width: "340px" },
            addDate: moment(date).clone().startOf("day").toDate(),
            defaultDate: moment(date).clone().startOf("day").toDate(),
            data: [],
          },
        ];
      }
      // if (typePeriod.id === "year") {
      //   let addDate = moment(date).clone().startOf("month").toDate();
      //   if (moment(addDate).unix() < moment().unix()) {
      //     addDate = moment().clone().toDate();
      //   }
      //   tempColumns = [
      //     ...tempColumns,
      //     {
      //       title: moment(date).format("MMMM"),
      //       style: { width: "520px" },
      //       addDate,
      //       defaultDate: moment(date).clone().startOf("month").toDate(),
      //       data: [],
      //     },
      //   ];
      // }
    });
    setColumns([...tempColumns]);
  }, [renderPeriodDate]);

  useEffect(() => {
    setCustomLoading(true);
    const controller = new AbortController();
    if (Object.keys(filters).length > 0) {
      setListDocuments([]);
      setRenderTableData([]);
      setFilterRenderTableData([]);
      setNextPage(null);
      getItemsRequest({
        listName: myDocumentsOWDCalendarWithRelationsListName,
        rowLimit: 1000,
        filters,
        sortOrder: { name: "ID", desc: true },
        otherParams: { valuePeriod },
        signal: controller.signal
      }).then((results: any) => {
        const { items, nextPage } = results;
        if (items.length > 0) {
          let emails: any = [];
          items.map((item: any) => {
            if (item.AuthorEmail) {
              emails = [...emails, item.AuthorEmail];
            }
            if (item.ResponsibleForRevisionEmail) {
              emails = [...emails, item.ResponsibleForRevisionEmail];
            }
            item.notifications.forEach((n: any) => {
              if (n.AuthorEmail) {
                emails = [...emails, n.AuthorEmail];
              }
              if (n.TestedEmployee) {
                emails = [...emails, n.TestedEmployee];
              }
              if (n.EmployeeEmail) {
                emails = [...emails, n.EmployeeEmail];
              }
            });
          });
          dispatch(addUsers(emails));
          setListDocuments([...items]);
          setCustomLoading(false);
          setNextPage(nextPage);
          setGetListDocuments(true);
        }
      });
    }
    return () => controller.abort();
  }, [JSON.stringify(filters), JSON.stringify(columns)]);

  useEffect(() => {
    if (nextPage && getListDocuments && scrollDown && Object.keys(filters).length > 0) {
      setCustomLoading(true);
      getItemsRequest({
        listName: myDocumentsOWDCalendarWithRelationsListName,
        rowLimit: 1000,
        filters,
        sortOrder: { name: "ID", desc: true },
        otherParams: { valuePeriod },
        nextPage
      }).then((results: any) => {
        const { items, nextPage } = results;
        let emails: any = [];
        items.map((item: any) => {
          if (item.AuthorEmail) {
            emails = [...emails, item.AuthorEmail];
          }
          if (item.ResponsibleForRevisionEmail) {
            emails = [...emails, item.ResponsibleForRevisionEmail];
          }
          item.notifications.forEach((n: any) => {
            if (n.AuthorEmail) {
              emails = [...emails, n.AuthorEmail];
            }
            if (n.TestedEmployee) {
              emails = [...emails, n.TestedEmployee];
            }
            if (n.EmployeeEmail) {
              emails = [...emails, n.EmployeeEmail];
            }
          });
        });
        dispatch(addUsers(emails));
        setListDocuments((prevState: any) => [...prevState, ...items]);
        setCustomLoading(false);
        setNextPage(nextPage);
        setScrollDown(false);
      });
    }
  }, [nextPage, scrollDown, JSON.stringify(filters), getListDocuments, JSON.stringify(columns)]);

  useEffect(() => {
    let renderTableData: any = [];
    listDocuments.forEach((item: any) => {
      let tempColumns: any = [];
      let filterValues: any = [];
      columns.forEach((column: any) => {
        if (column.defaultDate && (typePeriod.id === "week" || typePeriod.id === "month")) {
          tempColumns = [
            ...tempColumns,
            {
              ...column,
              data: item.notifications.filter(
                (owd_item: any) =>
                  owd_item.Completed
                    ? moment(owd_item.Completed).startOf("D").unix() === moment(column.defaultDate).startOf("D").unix()
                    : moment(owd_item.ReviewDate).startOf("D").unix() === moment(column.defaultDate).startOf("D").unix()
              ),
            },
          ];
        }
        // if (column.defaultDate && typePeriod.id === "year") {
        //   tempColumns = [
        //     ...tempColumns,
        //     {
        //       ...column,
        //       data: item.notifications.filter(
        //         (owd_item: any) =>
        //           owd_item.Document.id === item.ID &&
        //           moment(owd_item.ReviewDate).startOf("M").unix() === moment(column.defaultDate).startOf("M").unix()
        //       ),
        //     },
        //   ];
        // }
      });
      tempColumns.length > 0 &&
        tempColumns.forEach((column: any) => {
          if (column.data.length > 0) {
            filterValues = [...filterValues, 1];
          }
          if (column.data.some((owd: any) => owd.Completed)) {
            filterValues = [...filterValues, 3];
          }
          if (column.data.some((owd: any) => owd.Title && owd.Title.indexOf("Отклонено") !== -1)) {
            filterValues = [...filterValues, 6];
          }
          if (
            column.data.some((owd: any) => {
              const tempReviewDate = moment(owd.ReviewDate).clone().startOf("day");
              return (
                moment().clone().startOf("day").unix() > tempReviewDate.clone().subtract(7, "days").unix() &&
                !owd.Completed
              );
            })
          ) {
            filterValues = [...filterValues, 5];
          }
          if (
            column.data.some((owd: any) => {
              const tempReviewDate = moment(owd.ReviewDate).clone().startOf("day");
              return moment().clone().startOf("day").unix() > tempReviewDate.unix() && !owd.Completed;
            })
          ) {
            filterValues = [...filterValues, 4];
          }
        });
      if (tempColumns.filter((column: any) => column.data.length > 0).length === 0) {
        filterValues = [...filterValues, 2];
      }
      filterValues.sort((a: any, b: any) => {
        return a - b;
      });
      let filterValuesString = filterValues.join(",");
      // Опеределяем цвет для каждого уведомления в колонке
      tempColumns.forEach((column: any) => {
        column.data.forEach((owd: any, idx: number) => {
          column.data[idx]["colorClass"] = "bg-white hover:bg-[#637381] hover:text-white";
          column.data[idx]["color"] = "000000";
          const tempReviewDate = moment(owd.ReviewDate).clone().startOf("day");
          if (moment().clone().startOf("day").unix() > tempReviewDate.clone().subtract(7, "days").unix()) {
            column.data[idx]["colorClass"] = "bg-[#FEF3C7] hover:bg-[#EAD16E]";
            column.data[idx]["color"] = "EAD16E";
          }
          if (moment().clone().startOf("day").unix() > tempReviewDate.unix()) {
            column.data[idx]["colorClass"] = "bg-[#FBC0C0] hover:bg-[#D36E6E]";
            column.data[idx]["color"] = "D36E6E";
          }
          if (owd.Completed) {
            column.data[idx]["colorClass"] = "bg-[#ACEFC8] hover:bg-[#4AED8E]";
            column.data[idx]["color"] = "4AED8E";
          }
          if (owd.Title && owd.Title.indexOf("Отклонено") !== -1) {
            column.data[idx]["colorClass"] = "bg-[#E5E7EB] hover:bg-[#BBB]";
            column.data[idx]["color"] = "#BBB";
          }
        });
      });
      renderTableData = [
        ...renderTableData,
        {
          ID: item.ID,
          Code: item.Code,
          PublicationDate: item.PublicationDate,
          filterValuesString,
          Title: item.Title,
          Index: item.Index,
          style: { width: "267px" },
          columnsData: tempColumns.map((column: any) => {
            return {
              style: column.style,
              data: column.data,
              defaultDate: column.defaultDate,
              addDate: column.addDate,
            };
          }),
        },
      ];
    });
    setRenderTableData([...renderTableData]);
  }, [listDocuments]);

  useEffect(() => {
    let filterTempRenderTableData: any = [];
    let owdFilterArr: any = [];
    if (localFilters.length > 0) {
      for (let i = 0; i < localFilters.length; i++) {
        owdFilterArr = [...owdFilterArr, localFilters[i]["id"]];
      }
      owdFilterArr.sort((a: any, b: any) => {
        return a - b;
      });
      filterTempRenderTableData = renderTableData.filter((dataItem: any) => {
        return owdFilterArr.some((filterItem: any) => dataItem.filterValuesString.indexOf(String(filterItem)) !== -1);
      });
    } else {
      filterTempRenderTableData = [...renderTableData];
    }
    if (searchQuery.trim()) {
      filterTempRenderTableData = filterTempRenderTableData.filter((dataItem: any) => {
        const searchLower = searchQuery.toLowerCase().trim();
        const titleMatch = dataItem.Title?.toLowerCase().includes(searchLower);
        const codeMatch = dataItem.Code?.toLowerCase().includes(searchLower);
        const indexMatch = dataItem.Index?.toString().includes(searchQuery.trim());
        return titleMatch || codeMatch || indexMatch;
      });
    }
    setFilterRenderTableData([...filterTempRenderTableData]);
  }, [renderTableData, localFilters, searchQuery]);

  useEffect(() => {
    let tempStr = "";
    Object.keys(displayFilters).map((key: string, idx: number) => {
      if (idx <= 3) {
        if (Array.isArray(displayFilters[key])) {
          displayFilters[key].map((item: string, idx: number) => {
            if (displayFilters[key].length - 1 === idx) {
              tempStr += item;
            } else {
              tempStr += `${item}, `;
            }
          });
        } else {
          tempStr += `${displayFilters[key]}`;
        }
        tempStr += ", ";
      }
    });
    tempStr = tempStr.slice(0, -2);
    if (Object.keys(displayFilters).length > 4) {
      tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`;
    }
    setDisplayFiltersStr(tempStr);
  }, [displayFilters]);

  useEffect(() => {
    if (openImportExel) {
      setAllLoading(true);
      let exportTemp: any = [];
      async function fetchData() {
        const results = await getItemsRequest({
          listName: myDocumentsOWDCalendarWithRelationsListName,
          rowLimit: 1000000,
          filters,
          sortOrder: { name: "ID", desc: true },
          otherParams: { valuePeriod }
        });
        const { items } = results;
        let renderTableData: any = [];
        if (items.length > 0) {
          items.forEach((item: any) => {
            let tempColumns: any = [];
            let filterValues: any = [];
            columns.forEach((column: any) => {
              if (column.defaultDate && (typePeriod.id === "week" || typePeriod.id === "month")) {
                tempColumns = [
                  ...tempColumns,
                  {
                    ...column,
                    data: item.notifications.filter(
                      (owd_item: any) =>
                        owd_item.Completed
                          ? moment(owd_item.Completed).startOf("D").unix() === moment(column.defaultDate).startOf("D").unix()
                          : moment(owd_item.ReviewDate).startOf("D").unix() === moment(column.defaultDate).startOf("D").unix()
                    ),
                  },
                ];
              }
              // if (column.defaultDate && typePeriod.id === "year") {
              //   tempColumns = [
              //     ...tempColumns,
              //     {
              //       ...column,
              //       data: item.notifications.filter(
              //         (owd_item: any) =>
              //           owd_item.Document.id === item.ID &&
              //           moment(owd_item.ReviewDate).startOf("M").unix() === moment(column.defaultDate).startOf("M").unix()
              //       ),
              //     },
              //   ];
              // }
            });
            tempColumns.length > 0 &&
              tempColumns.forEach((column: any) => {
                if (column.data.length > 0) {
                  filterValues = [...filterValues, 1];
                }
                if (column.data.some((owd: any) => owd.Completed)) {
                  filterValues = [...filterValues, 3];
                }
                if (column.data.some((owd: any) => owd.Title && owd.Title.indexOf("Отклонено") !== -1)) {
                  filterValues = [...filterValues, 6];
                }
                if (
                  column.data.some((owd: any) => {
                    const tempReviewDate = moment(owd.ReviewDate).clone().startOf("day");
                    return (
                      moment().clone().startOf("day").unix() > tempReviewDate.clone().subtract(7, "days").unix() &&
                      !owd.Completed
                    );
                  })
                ) {
                  filterValues = [...filterValues, 5];
                }
                if (
                  column.data.some((owd: any) => {
                    const tempReviewDate = moment(owd.ReviewDate).clone().startOf("day");
                    return moment().clone().startOf("day").unix() > tempReviewDate.unix() && !owd.Completed;
                  })
                ) {
                  filterValues = [...filterValues, 4];
                }
              });
            if (tempColumns.filter((column: any) => column.data.length > 0).length === 0) {
              filterValues = [...filterValues, 2];
            }
            filterValues.sort((a: any, b: any) => {
              return a - b;
            });
            let filterValuesString = filterValues.join(",");
            // Опеределяем цвет для каждого уведомления в колонке
            tempColumns.forEach((column: any) => {
              column.data.forEach((owd: any, idx: number) => {
                column.data[idx]["colorClass"] = "bg-white hover:bg-[#637381] hover:text-white";
                column.data[idx]["color"] = "000000";
                const tempReviewDate = moment(owd.ReviewDate).clone().startOf("day");
                if (moment().clone().startOf("day").unix() > tempReviewDate.clone().subtract(7, "days").unix()) {
                  column.data[idx]["colorClass"] = "bg-[#FEF3C7] hover:bg-[#EAD16E]";
                  column.data[idx]["color"] = "EAD16E";
                }
                if (moment().clone().startOf("day").unix() > tempReviewDate.unix()) {
                  column.data[idx]["colorClass"] = "bg-[#FBC0C0] hover:bg-[#D36E6E]";
                  column.data[idx]["color"] = "D36E6E";
                }
                if (owd.Completed) {
                  column.data[idx]["colorClass"] = "bg-[#ACEFC8] hover:bg-[#4AED8E]";
                  column.data[idx]["color"] = "4AED8E";
                }
                if (owd.Title && owd.Title.indexOf("Отклонено") !== -1) {
                  column.data[idx]["colorClass"] = "bg-[#E5E7EB] hover:bg-[#BBB]";
                  column.data[idx]["color"] = "#BBB";
                }
              });
            });
            renderTableData = [
              ...renderTableData,
              {
                ID: item.ID,
                Code: item.Code,
                PublicationDate: item.PublicationDate,
                filterValuesString,
                Title: item.Title,
                Index: item.Index,
                style: { width: "267px" },
                columnsData: tempColumns.map((column: any) => {
                  return {
                    style: column.style,
                    data: column.data,
                    defaultDate: column.defaultDate,
                    addDate: column.addDate,
                  };
                }) || [],
              },
            ];
          });
          let filterTempRenderTableData: any = [];
          let owdFilterArr: any = [];
          if (localFilters.length > 0) {
            for (let i = 0; i < localFilters.length; i++) {
              owdFilterArr = [...owdFilterArr, localFilters[i]["id"]];
            }
            owdFilterArr.sort((a: any, b: any) => {
              return a - b;
            });
            filterTempRenderTableData = renderTableData.filter((dataItem: any) => {
              return owdFilterArr.some((filterItem: any) => dataItem.filterValuesString.indexOf(String(filterItem)) !== -1);
            });
          } else {
            filterTempRenderTableData = [...renderTableData];
          }
          if (searchQuery.trim()) {
            filterTempRenderTableData = filterTempRenderTableData.filter((dataItem: any) => {
              const searchLower = searchQuery.toLowerCase().trim();
              const titleMatch = dataItem.Title?.toLowerCase().includes(searchLower);
              const codeMatch = dataItem.Code?.toLowerCase().includes(searchLower);
              const indexMatch = dataItem.Index?.toString().includes(searchQuery.trim());
              return titleMatch || codeMatch || indexMatch;
            });
          }
          const tempDataHeaderExportExel = { ...filterTempRenderTableData[0] };
          let exportColumns: any = [
            {
              header: "",
              key: "link_doc",
              width: 50,
            },
          ];
          exportTemp = [
            {
              link_doc: "Документ",
            },
          ];
          tempDataHeaderExportExel.columnsData.forEach((column: any, idx: number) => {
            const dateTitle =
              (typePeriod.id === "week" || typePeriod.id === "month")
                ? moment(column.defaultDate).format("DD.MM.YYYY")
                : moment(column.defaultDate).format("MMMM");
            exportColumns = [
              ...exportColumns,
              // {
              //   header: dateTitle,
              //   key: `plan_${idx}`,
              //   width: 20,
              // },
              {
                header: dateTitle,
                key: `expert_${idx}`,
                width: 40,
              },
              {
                header: dateTitle,
                key: `tested_${idx}`,
                width: 40,
              },
              // {
              //   header: dateTitle,
              //   key: `fact_${idx}`,
              //   width: 20,
              // }
            ];
            exportTemp[0] = {
              ...exportTemp[0],
              // [`plan_${idx}`]: "",
              [`expert_${idx}`]: "Кто проводит OWD",
              [`tested_${idx}`]: "Кому проводят OWD",
              // [`fact_${idx}`]: "",
            };
          });
          filterTempRenderTableData.forEach((item: any) => {
            let tempEportDocData: any = {
              link_doc: {
                text: `${item.Code}.${item.Index}\n${item.Title}`,
                hyperlink: `${siteUrl}/dashboard/1/reports/2?documentCard=${item.ID}`,
                tooltip: item.Title,
              },
            };
            item.columnsData.forEach((columnData: any, idx: number) => {
              // const planRich: any[] = [];
              const expertRich: any[] = [];
              const testedRich: any[] = [];
              // const factRich: any[] = [];

              columnData.data.forEach((cell: any) => {
                // planRich.push({
                //   text: "", //`${moment(cell.ReviewDate).format("DD.MM.YYYY")}\n`,
                //   font: {
                //     size: 14,
                //     color: { argb: cell.color },
                //     name: "Calibri",
                //   },
                // });

                expertRich.push({
                  text: `${cell.EmployeeEmail || ''}\n`,
                  font: {
                    size: 14,
                    color: { argb: cell.color },
                    name: "Calibri",
                  },
                });

                testedRich.push({
                  text: `${cell.TestedEmployee || ''}\n`,
                  font: {
                    size: 14,
                    color: { argb: cell.color },
                    name: "Calibri",
                  },
                });

                // factRich.push({
                //   text: "", //`${cell.Completed ? moment(cell.Completed).format("DD.MM.YYYY") : ""}\n`,
                //   font: {
                //     size: 14,
                //     color: { argb: cell.color },
                //     name: "Calibri",
                //   },
                // });
              });

              // tempEportDocData[`plan_${idx}`] =
              //   planRich.length ? { richText: planRich } : "";

              tempEportDocData[`expert_${idx}`] =
                expertRich.length ? { richText: expertRich } : "";

              tempEportDocData[`tested_${idx}`] =
                testedRich.length ? { richText: testedRich } : "";

              // tempEportDocData[`fact_${idx}`] =
              //   factRich.length ? { richText: factRich } : "";
            });
            exportTemp = [...exportTemp, tempEportDocData];
          });
          const exportData = { columns: [...exportColumns], data: [...exportTemp] };
          const fileName = "OWD Calendar Documents";
          const type = "owd_calendar";
          setAllLoading(false);
          exportExcelFile(exportData, fileName, type, setOpenImportExel);
          setOpenImportExel(false);
        } else {
          setAllLoading(false);
          setOpenImportExel(false);
        }
      }
      fetchData();
    }
  }, [openImportExel]);

  return (
    <LayoutWithAsideAndContent
      aside={
        <FlexCol className="overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
          <CalendarOWDFilters
            setFilters={setFilters}
            setGetListDocuments={setGetListDocuments}
            setLocalFilters={setLocalFilters}
            filtersParams={filtersParams}
            defaultUserFilter={defaultUserFilter}
            setFiltersParams={setFiltersParams}
            userFilterCheck={userFilterCheck}
            reRenderUserFilter={reRenderUserFilter}
            setDisplayFilters={setDisplayFilters}
          />
        </FlexCol>
      }
      content={
        <FlexCol className="w-full">
          <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0 w-full gap-5">
            <FlexRow className="items-center justify-between gap-5 w-full">
              <nav className="flex justify-between w-full" aria-label="Breadcrumb">
                <FlexCol className="grow">
                  <ol className="inline-flex items-center">
                    <li className="inline-flex items-center" aria-current="page">
                      <Link
                        to="/dashboard/1/reports"
                        className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer"
                      >
                        <ReportIcon />
                        <span>Отчеты</span>
                      </Link>
                      <span className="px-3 text-body-color">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                            fill={"#637381"}
                          />
                        </svg>
                      </span>
                    </li>
                    <li className="inline-flex items-center" aria-current="page">
                      <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                        <StarIcon />
                        <span>Календарь OWD</span>
                      </div>
                    </li>
                  </ol>
                </FlexCol>
              </nav>
              <FlexRow className="items-center gap-2">
                <FavoriteButtonFilters filters={Object.keys(filters).length > 0 && JSON.stringify(filters) || ""} displayFilters={Object.keys(displayFilters).length > 0 && JSON.stringify(displayFilters) || ""} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} type='owd_calendar' />
                <FavoriteFiltersList reRenderTableFlag={setGetListDocuments} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} setFiltersParams={setFiltersParams} type='owd_calendar' filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} listQuestions={myDocumentsListName} setDefaultUserFilter={setDefaultUserFilter} setUserFilterCheck={setUserFilterCheck} userFilterCheck={userFilterCheck} setReRenderUserFilter={setReRenderUserFilter} />
              </FlexRow>
            </FlexRow>
            <Button
              classBg="btn-white min-w-[200px]"
              shadow={true}
              typeIcon="download"
              icon={true}
              text="Скачать в Excel"
              open={openImportExel}
              setOpen={setOpenImportExel}
            />
          </FlexRow>
          <FlexRow className="px-7.5 pt-7.5">
            <FlexCol className="w-full">
              <FlexRow className="w-full justify-between items-center py-3.5 px-10 rounded-lg shadow-custom bg-white mb-3.5">
                <FlexRow className="periodOWD gap-3.5">
                  <FlexRow className="w-full gap-3.5 items-center">
                    <FlexRow className="items-center w-fit">
                      <svg
                        onClick={prevDateHandle}
                        className="cursor-pointer text-[#9CA3AF] hover:text-[#1F2A37]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M14.2955 5.20451C13.8562 4.76517 13.1438 4.76517 12.7045 5.20451L6.70451 11.2045C6.49353 11.4155 6.375 11.7016 6.375 12C6.375 12.2984 6.49353 12.5845 6.70451 12.7955L12.7045 18.7955C13.1438 19.2348 13.8562 19.2348 14.2955 18.7955C14.7348 18.3562 14.7348 17.6438 14.2955 17.2045L9.09099 12L14.2955 6.7955C14.7348 6.35616 14.7348 5.64384 14.2955 5.20451Z"
                          fill="currentColor"
                        />
                      </svg>
                      <svg
                        onClick={nextDateHandle}
                        className="cursor-pointer text-[#9CA3AF] hover:text-[#1F2A37]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.7045 5.20451C10.1438 4.76517 10.8562 4.76517 11.2955 5.20451L17.2955 11.2045C17.5065 11.4155 17.625 11.7016 17.625 12C17.625 12.2984 17.5065 12.5845 17.2955 12.7955L11.2955 18.7955C10.8562 19.2348 10.1438 19.2348 9.7045 18.7955C9.26517 18.3562 9.26517 17.6438 9.7045 17.2045L14.909 12L9.7045 6.7955C9.26516 6.35616 9.26516 5.64384 9.7045 5.20451Z"
                          fill="currentColor"
                        />
                      </svg>
                    </FlexRow>
                    <FlexRow>
                      {typePeriod.id === "week" && (
                        <span>
                          {valuePeriod.start.label} - {valuePeriod.end.label}
                        </span>
                      )}
                      {typePeriod.id === "month" && (
                        <span className="first-letter:uppercase">{valuePeriod.start.label}</span>
                      )}
                      {typePeriod.id === "year" && <span>{valuePeriod.start.label}</span>}
                    </FlexRow>
                  </FlexRow>
                  <FlexRow className="min-w-[128px]">
                    <Select {...selectPeriodField} />
                  </FlexRow>
                </FlexRow>
                <FlexRow className="justify-end w-4/12">
                  <NotificationSendOWDCalendarButton
                    title="Запланировать OWD"
                    changeActive={(active: "get" | "send") => setLocalItem("notification_active", active)}
                    initialSubmit={{
                      documents: new Map(),
                      reviewDate: moment(new Date()).add(30, "day").toDate(),
                      comment: "",
                      employees: new Map(),
                      test: {
                        Questions: [],
                        IsQuestionFormOpen: false,
                        MinCorrectAnswersCount: 1,
                      },
                    }}
                  />
                </FlexRow>
              </FlexRow>
              <FlexRow className="mb-3.5">
                <FlexCol className="grow">
                  <SearchUI placeholder="Найти документ" defaultValue={searchQuery} onClick={handleSearch} />
                </FlexCol>
              </FlexRow>
              <OWDCalendarTable
                tableHeaderContent={columns}
                data={filterRenderTableData}
                typePeriod={typePeriod}
                setScrollDown={setScrollDown}
                filters={filters}
              />
              {!customLoading && filterRenderTableData.length === 0 &&
                <FlexCol className="w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                  <EmptyList title="Данные не найдены" />
                </FlexCol>
              }
              {!customLoading && filterRenderTableData.length > 0 && <div className="w-full my-2 py-2 text-center bg-[#012169] text-white">Список сформирован</div>}
              {customLoading && <div className="w-full my-2 py-2 text-center animate-pulse">Формируется список, пожалуйста подождите</div>}
            </FlexCol>
          </FlexRow>
          <Modal zIndex={120} open={openImportExel} toggleDialog={setOpenImportExel} modalClassName="min-h-px">
            {allLoading &&
              <FlexCol className="items-center justify-center mt-3 gap-5">
                <Loading />
                <span>Готовим файл для скачивания <br />Пожалуйста подождите...</span>
              </FlexCol>
            }
          </Modal>
        </FlexCol>
      }
    />
  );
}
